import { isNull, isUndefined } from 'lodash'

export const calculateBuyerPrice = ({
  wholesalePrice,
  percentage,
}: {
  wholesalePrice: number | null
  percentage: number
}) => {
  if (isNull(wholesalePrice) || isUndefined(wholesalePrice)) return null
  return parseFloat(
    (wholesalePrice + (wholesalePrice * percentage) / 100).toPrecision(8)
  )
}
